import { render } from "./SettingsTable.vue?vue&type=template&id=52a0c9a0"
import script from "./SettingsTable.vue?vue&type=script&lang=js"
export * from "./SettingsTable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__